import React, { useCallback, useEffect, useState } from 'react';
import { Modal } from '../../components/common/Modal';
import { shippingApi } from '../../api/shippingApi';
import { RequestFormPreview } from './RequestFormModal';
import { buildViewModelFromShipRequestDetail } from './shipRequestViewModel';

export function ShipRequestPreviewModal({ isOpen, requestNo, onClose }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    if (!isOpen || !requestNo) {
      setDetail(null);
      setError(null);
      return;
    }
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await shippingApi.getShipRequest(requestNo);
        if (!cancelled) setDetail(data);
      } catch (e) {
        if (!cancelled) {
          setDetail(null);
          setError(e?.response?.data?.detail || e?.message || '取得に失敗しました');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [isOpen, requestNo]);

  const handlePrint = useCallback(() => {
    const styleId = 'request-form-print-page-style';
    let styleEl = document.getElementById(styleId);
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = styleId;
      styleEl.textContent = '@page { size: A4 portrait; margin: 8mm; }';
      document.head.appendChild(styleEl);
    }
    document.body.classList.add('request-form-print');
    window.print();
    setTimeout(() => {
      document.body.classList.remove('request-form-print');
    }, 500);
  }, []);

  const viewModel = detail ? buildViewModelFromShipRequestDetail(detail) : null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={requestNo ? `出荷依頼書 ${requestNo}` : '出荷依頼書'}
      size="xl"
    >
      {loading && <p className="text-sm text-slate-600">読み込み中…</p>}
      {error && <p className="text-sm text-red-600 whitespace-pre-wrap">{String(error)}</p>}
      {viewModel && (
        <div className="space-y-3">
          <div className="request-form-print-root overflow-auto max-h-[60vh] border border-slate-200 rounded p-4 bg-white">
            <RequestFormPreview viewModel={viewModel} />
          </div>
          <div className="request-form-no-print flex justify-end gap-2">
            <button
              type="button"
              className="px-3 py-1.5 text-sm rounded border border-slate-300"
              onClick={onClose}
            >
              閉じる
            </button>
            <button
              type="button"
              className="px-3 py-1.5 text-sm rounded bg-slate-900 text-white"
              onClick={handlePrint}
            >
              印刷
            </button>
          </div>
        </div>
      )}
    </Modal>
  );
}
